import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, CommonModule, NgbTooltipModule, TranslocoDirective],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnDestroy {
  public isSidebarCollapsed = false;
  public isAnimating = false;

  private readonly compactQuery = window.matchMedia('(max-width: 1180px)');
  public isCompact = this.compactQuery.matches;
  private animationTimeoutId?: ReturnType<typeof setTimeout>;

  private readonly onCompactChange = (event: MediaQueryListEvent): void => {
    this.isCompact = event.matches;
  };

  constructor() {
    this.compactQuery.addEventListener('change', this.onCompactChange);
  }

  ngOnDestroy(): void {
    this.compactQuery.removeEventListener('change', this.onCompactChange);
    clearTimeout(this.animationTimeoutId);
  }

  public get isRailCollapsed(): boolean {
    return this.isSidebarCollapsed || this.isCompact;
  }

  public onToggleSidebar(): void {
    this.isAnimating = true;
    this.isSidebarCollapsed = !this.isSidebarCollapsed;

    clearTimeout(this.animationTimeoutId);
    this.animationTimeoutId = setTimeout(() => this.isAnimating = false, 300);
  }
}